import { trigger, style, transition, animate } from '@angular/animations';

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [
    style({opacity: 0 }),
    animate('500ms ease-in', style({opacity: 1 }))
  ]),
]);

export const slideWithFadeInOut = trigger('slideWithFade', [
  transition(':enter', [
    style({opacity: -0.5, height: 0 }),
    animate('250ms ease-in', style({opacity: 1, height: '*' }))
  ]),
  transition(':leave', [
    animate('250ms ease-in', style({opacity: -2, height: 0}))
  ])
])

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({opacity: 0 }),
    animate('250ms 1000ms ease-in', style({opacity: 1 }))
  ]),
  transition(':leave', [
    animate('250ms ease-in', style({opacity: 0}))
  ])
])

export const fadeInOutTighter = trigger('fadeTight', [
  transition(':enter', [
    style({opacity: 0 }),
    animate('250ms 250ms ease-in', style({opacity: 1 }))
  ]),
  transition(':leave', [
    animate('250ms ease-in', style({opacity: 0}))
  ])
])
